import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { RemoveFromCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/removeFromCart.trackingInfo";

import * as CartItemMapper from "../../mappers/cartItem.mapper";
import * as ProductMapper from "../../mappers/product.mapper";
import * as ProductTileProductMapper from "../../mappers/productTileProduct.mapper";
import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: RemoveFromCartTrackingInfo) => {
    const event: AnalyticsEvent<RemoveFromCartTrackingInfo> = {
        event: EventType.RemoveFromCart,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackCartItem = (cartItem: CartItem, quantity: number) => {
    const trackingInfo = CartItemMapper.toRemoveFromCartTrackingInfo({
        item: cartItem,
        quantity
    });

    track(trackingInfo);
};

export const trackProductTileProduct = (
    product: Product<ProductFieldSet.ProductTile>,
    quantity: number
) => {
    const trackingInfo = ProductTileProductMapper.toRemoveFromCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};

export const trackECommerceProduct = (
    product: Product<ProductFieldSet.Full>,
    quantity: number
) => {
    const trackingInfo = ProductMapper.toRemoveFromCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};
